import React from 'react'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Highlight4({data}) {
    const {highlight4ButtonText, highlight4ButtonLink, highlight4Text, highlight4Title} = data
    return (
        <div className='wemust-wrap res-we-must-wrp csp-wemust-wrap get-involved-work-sec font-white'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <div className='compresh-txt-cont'>
                            <div className='lg-font-140 yellow-gradient mb-3'>
                                {highlight4Title && parser(highlight4Title)}
                            </div>
                            <h2 className='heading-level-2-i white-color text-uppercase'>
                                {highlight4Text && parser(highlight4Text)}
                            </h2>
                        </div>
                    </div>
                    <div className='col-md-12 text-center'>
                        {highlight4ButtonLink && (
                            <Link to={highlight4ButtonLink.uri} className='btn blue-btn'>
                                {highlight4ButtonText}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
